import React from 'react';
import OsScroll from '../components/ui/OsScroll';

/**
 * Read-only blocks for an extension modal (`ui.openModal` spec):
 *
 *   { type: 'info', text, tone?: 'info' | 'warning' | 'danger' }  — a sentence or two
 *   { type: 'code', text }                                         — monospace, scrolls
 *
 * Both render TEXT ONLY (React escapes it) — an extension cannot put markup,
 * links or inputs into a host modal through these. They produce no value.
 *
 * Added 30.09.2026 so the DB Manager can show SQL it wants confirmed (Design
 * table's ALTER statements) in a place the user can actually see: its own
 * frame is invisible.
 */
const TONE_CLASS = {
  info: 'text-gray-600 dark:text-zinc-400',
  warning: 'text-amber-700 dark:text-amber-400',
  danger: 'text-red-600 dark:text-red-400',
};

export const TEXT_BLOCK_TYPES = new Set(['info', 'code']);

export default function ExtensionModalTextBlock({ field }) {
  const text = typeof field.text === 'string' ? field.text : '';
  if (field.type === 'code') {
    return (
      <OsScroll className="ext-modal-code" style={{ maxHeight: '40vh' }}>
        <pre
          className="m-0 p-3 text-xs font-mono whitespace-pre text-gray-800 dark:text-zinc-200"
          data-testid={`ext-modal-code-${field.id}`}
        >
          {text}
        </pre>
      </OsScroll>
    );
  }
  return (
    <p className={`m-0 text-sm ${TONE_CLASS[field.tone] || TONE_CLASS.info}`} data-testid={`ext-modal-info-${field.id}`}>
      {text}
    </p>
  );
}
